module.exports = __webpack_public_path__ + "img/synopsis_002.9495aab0.png";